export default "__VITE_ASSET__31c2ee38__"